<template>
    <div>
        <div class="row mt-5">
            <div class="col-lg-5">
                <div class="form-group row pb-4">
                    <label class="col-lg-3 pt-2" for="poli-select">Poli</label>
                    <div class="col-lg-8">
                        <select2 class="form-input" v-model="poli" :options="options_poli" id="poli-select" @change="getJadwalDokter"></select2>
                    </div>
                </div>
            </div>
        </div>

        <b-alert v-if="show_data" variant="success" show class="mt-3 text-center"><i class="fa fa-qrcode"></i> {{ alert }}</b-alert>
        <div id="data-jadwal-dokter"></div>
    </div>
</template>

<script>
import Select2 from 'v-select2-component'

export default {
    components: {
        Select2
    },
    data() {
        return {
            poli: 0,
            alert: '',
            show_data: false,
            jadwal_dokter: [],
            jadwal_poli: [],
            table: null,
            options_poli: [{id: 0, text: '----- Pilih Poli -----'}],
        }
    },
    created() {
        this.getPoli()
    },
    methods: {
        getJadwalDokter() {
            this.$isLoading(true)
            let uri = '/api/get_jadwal_dokter?poli=' + this.poli
            this.axios.get(uri).then(response => {
                let nama_hari = response.data.nama_hari

                this.jadwal_dokter = response.data.jadwal_dokter
                this.alert = 'JADWAL DOKTER POLI'
                this.show_data = true

                let kategori_jadwal = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let kode_poli_bpjs = data.kode_poli_bpjs

                    return kode_poli_bpjs ? 'BPJS & UMUM' : 'UMUM'
                }

                let keterangan = function (cell, formatterParams) {
                    let data = cell.getRow().getData()
                    let libur = data.libur

                    return libur == 0 ? 'Buka' : 'Tutup'
                }

                this.table = new Tabulator('#data-jadwal-dokter', {
                    layout: 'fitDataTable',
                    data: this.jadwal_dokter,
                    pagination: 'local',
                    paginationSize: 10,
                    paginationSizeSelector:[10, 25, 50, 100, true],
                    columns: [
                        {title: 'Hari', field: 'nama_hari'},
                        {title: 'Kategori', formatter: kategori_jadwal},
                        {title: 'Nama Dokter', field: 'nama_dokter', headerFilter: 'input'},
                        {title: 'Nama Poli', field: 'nama_poli', headerFilter: 'input'},
                        {title: 'Jam Mulai', field: 'jam_mulai', headerSort: false},
                        {title: 'Jam Selesai', field: 'jam_selesai', headerSort: false},
                        {title: 'Quota', field: 'kapasitas_pasien', headerSort: false},
                        {title: 'Keterangan', formatter: keterangan, headerSort: false},
                    ]
                })

                this.$isLoading(false)
            })
        },
        getPoli() {
            this.$isLoading(true)
            let uri = '/api/kuota_poli'
            this.axios.get(uri).then(response => {
                let jadwal_poli = response.data.data_poli

                this.options_poli = [{id: 0, text: '----- Pilih Poli -----'}]
                jadwal_poli.forEach(jdw_poli => {
                    this.options_poli.push({id: jdw_poli.kode_poli_internal, text: jdw_poli.poli_data.NMPoli})
                });

                this.$isLoading(false)
            })
        }
    }
}
</script>